import { Typography } from "@mui/material";

import type { ReactNode } from "react";

// Define the constraint for renderable types
type Renderable = ReactNode | string | number | null | undefined;

interface ShipmentInfoTextProps<T extends Renderable> {
  data: T;
}

export function ShipmentCustomNameText<T extends Renderable>(
  props: ShipmentInfoTextProps<T>,
) {
  const { data } = props;

  return (
    <Typography
      variant="body1"
      sx={{
        whiteSpace: "normal",
        overflow: "hidden",
        textOverflow: "ellipsis",
        wordBreak: "break-word",
        maxWidth: "100%",
      }}
    >
      Custom Name: <b>{data}</b>
    </Typography>
  );
}
